import { retrieveRawInitData } from '@tma.js/sdk-react'
import { mobileTrpcClient } from 'shared/api'
import { registerTelegramRefreshHandler } from 'shared/lib/auth/recovery'
import { installTelegramSession } from 'shared/lib/auth/session'
import type { User } from 'shared/store/auth'
import { retrieveTelegramUserId } from './identity'

/**
 * Exchanges Telegram raw initData for a session via the mobile tRPC bus.
 * Backend: mobile `auth.TelegramLogin({ initData }) -> { token, user }`.
 */
export async function telegramLogin(): Promise<{
	token: string
	expiresAt: number
	user: User
}> {
	const initData = retrieveRawInitData()
	if (!initData) {
		throw new Error('No Telegram init data available')
	}
	return mobileTrpcClient.auth.TelegramLogin.mutate({ initData })
}

registerTelegramRefreshHandler(async () => {
	const telegramId = retrieveTelegramUserId()
	if (telegramId === null) throw new Error('No Telegram user ID available')
	const session = await telegramLogin()
	installTelegramSession(session, telegramId)
	return session.token
})
